<template>
  <div class="css-grid battery-order-view__row">
    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell">
        {{ product.battery_line }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell">
        {{ product.size }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell">
        {{ product.pack_option }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell h-helper-text">
        {{ product.description }}<br />
        ({{ pricePerCell }}/per cell)
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell">
        {{ product.imprint }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell h-center-align">
        {{ product.quantity }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell h-center-align">
        {{ itemPrice }}
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell h-center-align">
        {{ totalBatteries }} batteries
      </div>
    </div>

    <div class="css-grid battery-order-view__order">
      <div class="battery-order-view__cell battery-order-view__cell--remove h-center-align" v-tooltip="{ content: 'Remove Product from Cart' }">
        <span @click.prevent="removeItem" class="glyphicon glyphicon-remove" aria-hidden="true"></span>
      </div>
    </div>

  </div>
</template>

<script>
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'Product',
    mixins: [DataMethods],
    props: ['product', 'index'],
    computed: {
      itemPrice () {
        if (this.product.imprint === 'No Imprint') {
          return this.currency(this.product.quantity * this.product.base_price / 100, '$', 2);
        } else {
          return this.currency(this.product.quantity * this.product.price_imprint / 100, '$', 2);
        }
      },
      pricePerCell() {
        if (this.product && parseInt(this.quantity) > 0 && this.imprint) {
          if (this.imprint === 'No Imprint') {
            return this.currency((this.product.base_price / this.product.total_batteries) / 100, '$', 2);
          } else {
            return this.currency((this.product.price_imprint / this.product.total_batteries) / 100, '$', 2);
          }
        }
        return '';
      },
      totalBatteries() {
        return this.product.quantity * this.product.total_batteries;
      },
    },
    methods: {
      removeItem() {
        this.$store.dispatch('batteryStore/removeItem', this.index);
      },
    },
  };
</script>
